module.exports = __webpack_public_path__ + "img/bti-company-letter.f1ebdbbb.png";